import { createAsyncThunk } from '@reduxjs/toolkit';
import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export const removeProjectToMergeInto = createAsyncThunk(
  'projects/removeProjectToMergeInto',
  async (_, { getState }) => {
    const state = getState();

    const selectedProjectId = state?.root?.project?.id;

    if (!selectedProjectId) {
      throw new Error('No project selected');
    }

    const apiPath = `projects/${selectedProjectId}/remove-project-to-merge-into`;

    const request = {
      //url: `http://localhost:3001/${apiPath}`,
      url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
      host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
      path: apiPath,
      method: 'PATCH',
      region: Config.AWS_REGION,
      service: 'execute-api',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const signedRequest = await createSignedRequest(request);

    const response = await axios(signedRequest);

    return response.data;
  }
);
